<template>
    <a :href="`/admin/pages/zones/${item.id}`">
        <span
            class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
            {{ item.name }}
        </span>
    </a>
</template>

<script>
export default {
    name: "ZoneItem",

    props: ['item'],
}
</script>

<style scoped>

</style>
